/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const candidateInterviewBookingDataStatusSchema = z.enum(['confirmed', 'cancelled'])

export type CandidateInterviewBookingDataStatusSchema = z.infer<typeof candidateInterviewBookingDataStatusSchema>
